<template>
  <div class="m-4 mx-6 flex justify-center items-start flex-col">
    <SettingsOption label="Keys" tooltip="Keys to which the rule applies">
      <span class="label-text">
        {{ keysText }}
      </span>
    </SettingsOption>

    <SettingsOption
      label="Condition"
      tooltip="Condition required for the rule to be active"
    >
      <!-- <div class="max-w-xs"> -->
      <div class="flex justify-start items-center flex-wrap">
        <ConditionView :condition="rule.condition" />
      </div>
      <!-- </div> -->
    </SettingsOption>

    <SettingsOption
      label="Pattern"
      tooltip="Color pattern used for a LED when the rule applies"
    >
      <div class="flex justify-start items-center gap-1 flex-wrap">
        <Icon :icon="REPEAT_ICON[rule.pattern.repeat]" class="mr-2" />

        <div
          v-for="(trans, id) in rule.pattern.transitions"
          :key="id"
          class="h-6 flex justify-center items-center border rounded-xl border-base-content/20"
        >
          <Icon
            class="mx-0.5"
            :icon="
              trans.interpolation == 'Linear'
                ? 'mdi:arrow-top-right-thin'
                : 'mdi:stairs'
            "
          />

          <Icon v-if="trans.duration === 0" icon="mdi:infinity" />
          <span v-else>{{ trans.duration }}</span>

          <div
            class="w-4 h-4 mx-1 rounded-full"
            :style="{ 'background-color': hexColor(trans) }"
          ></div>
        </div>
      </div>
    </SettingsOption>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { colord } from "colord";
import { LedRule, Repeat, Transition, RGB8 } from "@/keyboard";
import { keysDescription } from "@/keyboard/keys_utils";
import SettingsOption from "@/components/utils/SettingsOption.vue";
import ConditionView from "@/components/leds/ConditionView.vue";
import { Icon } from "@iconify/vue";

const props = defineProps<{
  rule: LedRule;
}>();

const keys = computed(() =>
  props.rule.keys == undefined ? null : props.rule.keys
);
// TODO: add warning about no keys selected (like in keyboard config, see warnings.ts)
const keysText = computed(() => keysDescription(keys.value));

const REPEAT_ICON: Record<Repeat, string> = {
  Once: "mdi:arrow-right",
  Wrap: "mdi:arrow-u-left-bottom",
  Reflect: "mdi:arrow-left-right",
};

const fromRgb8 = (c: RGB8) => ({ r: c[0], g: c[1], b: c[2] });
const hexColor = (t: Transition) => colord(fromRgb8(t.color)).toHex();
</script>
